import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import BaseClass from "../BaseClass.js";

window.Pusher = Pusher;
export default class LaravelEcho extends BaseClass {

    constructor(element) {
        super(element);

        this.channelType = null;
        this.channelName = null;

        this.initEcho();


        let channelType = this.$element.attr('data-channel-type');
        if (channelType != undefined && channelType.length > 0) {
            this.channelType = channelType;
        }

        let channelName = this.$element.attr('data-channel');
        if (channelName != undefined && channelName.length > 0) {
            this.channelName = channelName;
        }

        switch (this.channelType) {
            case 'private':
                this.initPrivateChannel(this.channelName);
                break;

            case 'presence':
                this.initPresenceChannel(this.channelName);
                break;

            default:
                this.initChannel(this.channelName);
        }
    }

    initChannel(channelName) {
        window.Echo.channel(channelName)
            .listen('eventName', (event) => {
                console.log(event);
            });
    }

    initPrivateChannel(channelName) {
        console.error("init " + channelName);
        // events müssen einzeln eingetragen werden.
        window.Echo.private(channelName).listen('eventName', (event) => {
            console.log(event);
            console.error(event);
        });
    }

    initPresenceChannel(channelName) {
// Testcase, nicht für den produktiven Einsatz gedacht.
        window.Echo.join('chat.2')
            .here((users) => {
                console.error(users);
            })
            .joining((user) => {
                console.error(user);
            })
            .leaving((user) => {
                console.error('leaving');
                console.error(user);

                setInterval(function () {
                    console.error('sent message');
                    window.Echo.connector.pusher.send_event('SendMessage', 'Meine Testmessage', 'chat2');
                }, 5000);


            })
            .error((error) => {
                console.error(error);
            });

    }

    initEcho() {
        if (window.Echo != null) {
            return;
        }
        window.Echo = new Echo({
            broadcaster: 'reverb',
            key: process.env.MIX_REVERB_APP_KEY,
            wsHost: process.env.MIX_REVERB_HOST,
            wsPort: process.env.MIX_REVERB_PORT,
            wssPort: process.env.MIX_REVERB_PORT,
            forceTLS: (process.env.MIX_REVERB_SCHEME ?? 'https') === 'https',
            enabledTransports: ['ws', 'wss'],

        });

        /*
         window.Echo.connector.pusher.connection.bind('connecting', (payload) => {
                    console.log('Websocket connecting...');
                });
                window.Echo.connector.pusher.connection.bind('connected', (payload) => {
                    console.log('Websocket connected.', payload);
                });
                window.Echo.connector.pusher.connection.bind('unavailable', (payload) => {
                    console.log('Websocket unavailable.', payload);
                });
                window.Echo.connector.pusher.connection.bind('failed', (payload) => {
                    console.log('Websocket failed.', payload);
                });
                window.Echo.connector.pusher.connection.bind('disconnected', (payload) => {
                    console.log('Websocket disconnected.', payload);
                });
                window.Echo.connector.pusher.connection.bind('message', (payload) => {
                    console.log('Message received.', payload);
                });
         */
    }

}